var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone",
    d: "M34,68A34.009,34.009,0,0,1,20.766,2.672,34.009,34.009,0,0,1,47.235,65.328,33.787,33.787,0,0,1,34,68ZM20.578,18A2.581,2.581,0,0,0,18,20.578,29.576,29.576,0,0,0,47.543,50.12a2.581,2.581,0,0,0,2.578-2.578V41.66a2.58,2.58,0,0,0-2.578-2.577,18.212,18.212,0,0,1-5.727-.913,2.436,2.436,0,0,0-.789-.126,2.515,2.515,0,0,0-1.757.662l-3.612,2.727a20.02,20.02,0,0,1-8.974-8.972l2.646-3.517a2.6,2.6,0,0,0,.639-2.631,18.26,18.26,0,0,1-.915-5.737A2.581,2.581,0,0,0,26.476,18Z",
    fill: "#66d15f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a5ce5756.svg";
export { ForwardRef as ReactComponent };